import React, {useRef, useState, useEffect} from 'react'
import moment from 'moment'
import WeekTimeSelector from './WeekTimeSelector'
import CurrentTimeIndicator from './CurrentTimeIndicator'

const WeekDay = ({date, times = [], disableDatesBefore, onInitScroll}) => {
  const refCurrentTimeIndicator = useRef(null)

  useEffect(() => {
    refCurrentTimeIndicator.current.classList.remove('c-current-time-indicator--current')
    if (!disableDatesBefore || !date) {
      return null
    }
    // current month
    if (
      disableDatesBefore.get('month') === date.get('month') &&
      disableDatesBefore.get('year') === date.get('year') &&
      disableDatesBefore.get('date') === date.get('date')
    ) {
      const percHeight =
        ((disableDatesBefore.get('hour') * 60 + disableDatesBefore.get('minutes')) / 1440) * 100
      refCurrentTimeIndicator.current.style.height = `${percHeight}%`
      refCurrentTimeIndicator.current.classList.add('c-current-time-indicator--current')
      onInitScroll(percHeight)
    }
    // prev
    if (
      disableDatesBefore.get('month') <= date.get('month') &&
      disableDatesBefore.get('year') <= date.get('year') &&
      disableDatesBefore.get('date') < date.get('date')
    ) {
      refCurrentTimeIndicator.current.style.height = `0px`
    }
    // next
    if (
      disableDatesBefore.get('month') >= date.get('month') &&
      disableDatesBefore.get('year') >= date.get('year') &&
      disableDatesBefore.get('date') > date.get('date')
    ) {
      refCurrentTimeIndicator.current.style.height = `100%`
    }
  }, [disableDatesBefore, date, onInitScroll])

  return (
    <div className="c-calendar-week__cell-column" style={{position: 'relative'}}>
      <CurrentTimeIndicator
        ref={refCurrentTimeIndicator}
        date={date}
        disableDatesBefore={disableDatesBefore}
      />
      {/* <WeekTimeSelector ref={refWeekTime} /> */}
      {times.map(t => (
        <div className="c-calendar-week__cell"></div>
      ))}
    </div>
  )
}

export default WeekDay
